"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSPowerpoint = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1a7.02 7.02 0 0 0-7 7l8.868 1.868L9 1Z",
    fill: "#ED6C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1a7.02 7.02 0 0 1 7 7l-3.5 2.379L9 8V1Z",
    fill: "#FF8F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15a7.02 7.02 0 0 0 7-7H2a7.02 7.02 0 0 0 7 7Z",
    fill: "#D35230"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.333 3.5h-4.68a6.957 6.957 0 0 0 .465 9.5h4.215A.668.668 0 0 0 9 12.334V4.166a.668.668 0 0 0-.667-.666Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.833 4H3.27a6.953 6.953 0 0 0 1.422 9.5h3.141a.668.668 0 0 0 .667-.666V4.666A.668.668 0 0 0 7.833 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.833 4H3.27a6.945 6.945 0 0 0 .383 8.5h4.18a.668.668 0 0 0 .667-.666V4.667A.668.668 0 0 0 7.833 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.333 4H3.27a6.945 6.945 0 0 0 .383 8.5h3.68A.668.668 0 0 0 8 11.834V4.667A.668.668 0 0 0 7.333 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.666 4h6.667A.667.667 0 0 1 8 4.667v6.667a.666.666 0 0 1-.667.666H.667A.666.666 0 0 1 0 11.334V4.667A.667.667 0 0 1 .666 4Z",
    fill: "#C43E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.998 5.5c.493-.033.981.11 1.378.403a1.439 1.439 0 0 1 .478 1.165c.005.283-.077.56-.237.794a1.582 1.582 0 0 1-.671.593c-.317.147-.662.22-1.01.212H2.98V10.5H2v-5h1.998ZM2.98 7.842h.844c.267.02.532-.06.745-.222a.554.554 0 0 0 .253-.513c0-.553-.323-.83-.967-.83H2.98v1.565Z",
    fill: "#F9F7F7"
  })));
});
var _default = MSPowerpoint;
exports["default"] = _default;